const {
  REACT_APP_API_AUTH_URL = 'http://localhost:8080/v1/auth',
  REACT_APP_API_URL = 'http://localhost:8080/v1/api',
} = process.env;

export const API_AUTH_CREDENTIALS_URL = `${REACT_APP_API_AUTH_URL}/local/credentials`;
export const API_AUTH_LOGIN_URL = `${REACT_APP_API_AUTH_URL}/local/login`;
export const API_RESET_CREDENTIALS_REQUEST = `${REACT_APP_API_AUTH_URL}/local/credentials/reset-request`;
export const API_UPDATE_CREDENTIALS = `${REACT_APP_API_AUTH_URL}/local/credentials/reset/{token}`;
export const API_AUTH_TOKEN_URL = `${REACT_APP_API_AUTH_URL}/token`;

export const API_USERS_URL = `${REACT_APP_API_URL}/users`;

export const API_USER_URL = `${REACT_APP_API_URL}/users/{userId}`;
export const API_USER_PASSPHRASE_URL = `${REACT_APP_API_URL}/users/{userId}/passphrase`;
export const API_USER_EMPLOYMENT_URL = `${REACT_APP_API_URL}/users/{userId}/employment`;
export const API_USER_DISCLOSURES_URL = `${REACT_APP_API_URL}/users/{userId}/disclosures`;
export const API_USER_DOWNLOADS_URL = `${REACT_APP_API_URL}/users/{userId}/downloads`;
export const API_USER_DOWNLOAD_URL = `${REACT_APP_API_URL}/users/{userId}/downloads/{type}/{reportId}?download={download}&authToken={authToken}`;
export const API_USER_FILE_URL = `${REACT_APP_API_URL}/users/{userId}/files/{userFileName}?authToken={authToken}`;
export const API_USER_MEMBER_UPLOADS_URL = `${REACT_APP_API_URL}/users/{userId}/member-uploads`;
export const API_USER_ACCREDITATION_STATUS_URL = `${REACT_APP_API_URL}/users/{userId}/accreditation-status`;
export const API_USER_DETAIL_URL = `${REACT_APP_API_URL}/user-details/{userId}`;

export const API_ACCOUNTS_URL = `${REACT_APP_API_URL}/accounts`;
export const API_ACCOUNT_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}`;
export const API_ACCOUNT_CASH_BALANCE_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/cash-balance`;
export const API_ACCOUNT_POSITIONS_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/positions`;
export const API_ACCOUNT_PERFORMANCE_RAW_DATA_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/performance-raw-data`;
export const API_ACCOUNT_PERFORMANCE_SUMMARY_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/performance-summary`;
export const API_ACCOUNT_TRANSACTIONS_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/transactions?dateRangeCode={dateRangeCode}`;
export const API_ACCOUNT_ORDERS_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/orders`;
export const API_ACCOUNT_ORDER_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/orders/{orderId}`;
export const API_ACCOUNT_CASH_TRANSACTIONS_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/cash-transactions?dateRangeCode={dateRangeCode}`;
export const API_ACCOUNT_BANK_LINKS_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/bank-links`;
export const API_ACCOUNT_BANK_LINK_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/bank-links/{bankLinkId}`;
export const API_ACCOUNT_DEPOSITS_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/cash-transfers/deposits`;
export const API_ACCOUNT_WITHDRAWALS_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/cash-transfers/withdrawals`;
export const API_ACCOUNT_INSTRUCTIONS_WIRE_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/cash-transfers/instructions/wire`;
export const API_ACCOUNT_INSTRUCTIONS_CHECK_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/cash-transfers/instructions/check`;
export const API_ACCOUNT_CANCEL_TRANSFER = `${REACT_APP_API_URL}/accounts/{accountNumber}/cash-transfers/cancel/{transferId}`;
export const API_ACCOUNT_RESTRICTIONS_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/restrictions`;
export const API_ACCOUNT_DOWNLOADS_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/downloads`;
export const API_ACCOUNT_DOWNLOAD_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/downloads/{type}/{year}?download={download}&authToken={authToken}`;
export const API_OFFERINGS_URL = `${REACT_APP_API_URL}/offerings`;
export const API_OFFERING_URL = `${API_OFFERINGS_URL}/{offeringId}`;
export const API_LOCAL_ACCOUNT_RESTRICTIONS_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/localrestrictions`;


export const API_QUOTES_SNAPQUOTES_URL = `${REACT_APP_API_URL}/quotes/snap-quotes/{symbols}`;
export const API_QUOTES_ENHANCEDSNAPQUOTES_URL = `${REACT_APP_API_URL}/quotes/enhanced-snap-quotes/{symbols}`;
export const API_QUOTES_CHARTDATA_URL = `${REACT_APP_API_URL}/quotes/chart-data/{symbols}/?start={startDate}&interval={interval}`;
export const API_QUOTES_PRIVATE_URL = `${REACT_APP_API_URL}/quotes/private-quotes/{symbols}`;

export const API_OFFERING_DOCUMENTS_URL = `${API_OFFERINGS_URL}/{offeringId}/documents`;
export const API_OFFERING_DOCUMENT_URL = `${API_OFFERING_DOCUMENTS_URL}/{offeringDocumentId}?authToken={authToken}`;

export const API_OFFERING_SUBSCRIPTIONS_URL = `${API_ACCOUNT_URL}/offeringSubscriptions`;
export const API_OFFERING_SUBSCRIPTION_URL = `${API_ACCOUNT_URL}/offeringSubscriptions/{offeringSubscriptionId}`;
export const API_OFFERING_ORDER_URL_W_PARAMS = `${API_ACCOUNT_URL}/offer-orders?includeCanceled={includeCanceled}`;
export const API_OFFERING_ORDER_URL = `${API_ACCOUNT_URL}/offer-orders`;
export const API_OFFERING_WATCHES = `${REACT_APP_API_URL}/offering-watches`;
export const API_OFFERING_INDICATE_INTEREST = `${REACT_APP_API_URL}/offering-watches/{offerId}`;
export const API_OFFERING_WATCH_CANCEL_INDICATION = `${REACT_APP_API_URL}/offering-watches/{token}/remove`;
export const API_PLAID_LINK_SETTINGS_URL = `${REACT_APP_API_URL}/users/{userId}/bank-links/plaid/link-settings`;
export const API_VERIFY_EMAIL_URL = `${REACT_APP_API_URL}/verify-email`;

export const API_BASE_URL = REACT_APP_API_URL.replace(/v\d+\/.*$/, '');

export const SUPPORT_EMAIL = 'clientservices@myipo.com';

export const API_SUITABILITYINFO_URL = `${REACT_APP_API_URL}/suitability-information/{suitabilityInfoId}`;
export const API_CONFIGS_URL = `${REACT_APP_API_URL}/configs`;

/**
 * Replaces placeholders in the string with values from mapObj
 * @example
 *   str = 'Hello {name}, today is {today}'
 *   name = 'Alice';
 *   today: 'Monday',
 *   replacePlaceholders(str, { name, today })
 *
 * Returns 'Hello Alice, today is Monday'
 *
 * Based on https://stackoverflow.com/a/15604206
 */
export const replacePlaceholders = (str, mapObj) => str.replace(
  new RegExp(Object.keys(mapObj).map(key => `{${key}}`).join('|'), 'gi'),
  matched => mapObj[matched.substring(1, matched.length - 1)],
);



// WEBPACK FOOTER //
// ./src/actions/urls.js